<template>

    <div id="password-reset">
        <img class="logo" alt="Lewis Rice" src="../assets/images/lewis-rice-logo-white.svg">
        <h1>Estate Planning Document Portal</h1>
        <div v-if="!resetComplete">
            <div class="form-group">
                <input type="text" name="username" readonly disabled v-model="username" placeholder="email">
            </div>
            <div class="form-group">
                <input type="password" name="password" v-model="newPassword" placeholder="new password">
            </div>
            <div class="form-group">
                <input type="password" name="confirmPassword" v-model="confirmPassword" placeholder="confirm password">
            </div>
            <div class="form-group">
                <button class="btn btn-lg btn-primary" v-bind:disabled="!passwordsMatch" type="submit" @click="setPassword">Set Password</button>
            </div>
            <div>
                <p><router-link to="/login">Back to login</router-link></p>
            </div>
        </div>
        <div v-if="resetComplete">
            <h2>Your password has been set.</h2>
            <div class="form-group">
                <router-link to="/"><button class="btn btn-lg btn-primary">Continue</button></router-link>
            </div>
        </div>
    </div>

</template>



<script>

    import router from '@/router'
    import UserService from '@/services/user.service'

    export default {

        name: 'passwordReset',

        data() {
            return {
                newPassword: '',
                confirmPassword: '',
                resetComplete: false
            }
        },

        created: function() {
            UserService.logout()
        },

        computed: {
            passwordsMatch : function() {
                return (this.newPassword != '') && (this.newPassword == this.confirmPassword);
            },
            token: function() { return this.$route.query.token; },
            username: function() { return this.$route.query.username; },
            newaccount: function() { return typeof this.$route.query.newaccount != 'undefined'; }
        },

        methods: {
            setPassword: function() {
                console.log('newaccount', this.newaccount)

                UserService.resetPassword(this.username, this.newPassword, this.token, this.newaccount)
                    .then(use.bind(this))

                function use(data) {
                    this.resetComplete = true;
                }

            }
        }
    }

</script>



<style lang="scss">

    @import "../variables";

    #password-reset {

        input {
            padding: .5em;
            background-color: #eee;
            border: 2px dotted #ddd;
        }

        .logo {
            display: inline-block;
            margin: 2rem 0 0 0;
            width: 70%;
            height: auto;
            max-width: 400px;
        }

        h1 {
            text-transform: uppercase;
            font-size: 1.2rem;
            letter-spacing: 0.3em;
            color: #999;
            line-height: 1.2;
            font-weight: 300;
            margin: 2rem 0 3rem 0;
        }

        h2 {
            color: #ddd;
        }

        input[type="text"],
        input[type="password"],
        input[type="email"] {
            color: #fff;
            background-color: transparent;
            border: none;
            border-bottom: 1px solid #fff;
            padding: 0.2em;
            font-size: 1.4rem;
        }

        button {
            margin-top: 2rem;
            text-transform: uppercase;
            letter-spacing: 0.1em;
        }

        a {
            text-decoration: none;

            &:focus {
                color: #fff;
            }
        }

        .get-login-help {
            color: #ddd;

            h3,
            h4 {
                font-weight: normal;
            }
        }

        .alert {
            text-align: left;
        }
    }

</style>



// WEBPACK FOOTER //
// PasswordReset.vue?72c50c69